<script lang="ts">
  import type { ClosingState } from '@pin/schemas/client-state-response';
  import { format } from 'date-fns';
  import { onMount } from 'svelte';
  import AlternativeList from '../components/AlternativeList.svelte';
  import ConfettiCharger from '../components/ConfettiCharger.svelte';
  import CouldNotVote from '../components/CouldNotVote.svelte';
  import FurtherNavigation from '../components/FurtherNavigation.svelte';
  import Alternative from '../components/MGP/Alternative.svelte';
  import voteStore from '../stores/voteStore';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';
  export let pollData: ClosingState;

  $: closeTime = format(new Date(pollData.endTime), "' kl. 'HH:mm");

  onMount(() => {
    trackEvent(
      { action: 'state:closed-poll', label: pollData.title },
      pollData.id
    );
  });
</script>

{#if $voteStore != null}
  <!-- svelte-ignore a11y-autofocus -->
  <h2 autofocus tabindex="-1">{i18n('poll.thanks-for-vote')}</h2>
  <p>{i18n('poll.closed', { values: { closeTime } })}</p>
  <ConfettiCharger />
{:else}
  <!-- svelte-ignore a11y-autofocus -->
  <h2 autofocus tabindex="-1">Avstemningen er avsluttet</h2>
  <p>{i18n('poll.closed', { values: { closeTime } })}</p>
{/if}
{#if $voteStore == null}
  <CouldNotVote endTime={pollData.endTime} />
{:else}
  <h3 class="artists-list-header">ARTISTER</h3>
  <AlternativeList>
    {#each pollData.alternatives as alternative, i}
      <Alternative
        reverse={i % 2 === 0 ? false : true}
        artist={alternative}
        votedArtistId={$voteStore[0]}
        submitted={$voteStore != null}
      />
    {/each}
  </AlternativeList>
  <FurtherNavigation />
{/if}

<style>
  p {
    margin-bottom: 2rem;
  }
</style>
